import {
  XButton,
  XPlayerResources,
  XResourceWithAmount,
  XTypography,
} from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useViewingPlayerOpt } from "~/jsx/hook";
import { useModal } from "~/utils";

export const XViewingPlayerResources = () => {
  const player = useViewingPlayerOpt();
  const { show: showShop } = useModal(ModalNames.shop);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: 40,
        alignItems: "center",
      }}
    >
      <XButton variant="action" onClick={() => showShop()}>
        Shop
      </XButton>
      {player ? (
        <>
          <XResourceWithAmount
            type="influence"
            amount={player.influencePoints}
            width={32}
          />
          {player && <XPlayerResources player={player} />}
          <XResourceWithAmount
            type="victory"
            amount={player.victoryPoints}
            width={24}
            variant="separated"
          />
        </>
      ) : (
        <XTypography>Spectator mode</XTypography>
      )}
    </div>
  );
};
